exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hr-personal[data-v-670661bb] {\n    border: 0.5px solid lightgray;\n}\n.hr-personal-blue[data-v-670661bb] {\n    border: 1px solid blue;\n}\n", ""]);

// exports
